import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Looks6Icon(props: IconProps) {
    return <Icon {...props} iconKey={"looks_6"}/>
}
